import React, { Component } from 'react'
//import items from './data'
import Client from './contentful'
//Client.getEntries().then(response => console.log(response.items));
const MenuContext = React.createContext();
//
class MenuProvider extends Component {
    state = {
        menu: [],
        sortedMenu: [],
        featuredMenu: [],
        loading: true,
        type: "All",
        portion: 1,
        price: 0,
        minPrice: 0,
        maxPrice: 0,
        minPortion: 0,
        maxPortion: 1,
        glutenFree: false,
        vegeterian: false,
        searchMenu: ''
    };
    // getData function for "contentful" API call
    getData = async () => {
        try {

            let response = await Client.getEntries({
                content_type: "ozen",
                limit: 200,
                order: "fields.price"
            });

            let menu = this.formatData(response.items);

            // var key, count = 0;
            // for (key in menu) {
            //     if (menu.hasOwnProperty(key)) {
            //         count++;
            //     }
            // }
            let featuredMenu = menu.filter(menu => menu.featured === true);
            let maxPrice = Math.max(...menu.map(item => item.price));

            let maxPortion = Math.max(...menu.map(item => item.portion));
            this.setState({
                menu,
                featuredMenu,
                sortedMenu: menu,
                loading: false,
                price: maxPrice,
                maxPrice,
                maxPortion
            });

        } catch (error) {
            console.log(error);
        }
    }
    componentDidMount() {
        this.getData();
        // let menu = this.formatData(items);
        // let featuredMenu = menu.filter(menu => menu.featured === true);
        // let maxPrice = Math.max(...menu.map(item => item.price));
        // console.log(maxPrice);
        // let maxPortion = Math.max(...menu.map(item => item.portion));
        // this.setState({
        //     menu,
        //     featuredMenu,
        //     sortedMenu: menu,
        //     loading: false,
        //     price: maxPrice,
        //     maxPrice,
        //     maxPortion
        // });

    }
    formatData(items) {
        let tempItems = items.map(item => {

            let id = item.sys.id;
            let images = item.fields.images.map(image => image.fields.file.url);

            let menu = { ...item.fields, images, id };

            return menu;
        });
        //  console.log(tempItems)
        return tempItems;
    }
    getMenu = (slug) => {
        let tempMenu = [...this.state.menu];
        const menu = tempMenu.find(menu => menu.slug === slug);

        return menu;
    }

    handleChange = event => {
        const target = event.target;
        //console.log(event.target.value);
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = event.target.name;
        if (name === 'search') {
            this.setState({
                searchMenu: value
            })
        }
        this.setState({
            [name]: value
        }, this.filterMenu)
    };
    filterMenu = () => {
        let {
            menu, type, portion, price, vegeterian, glutenFree, searchMenu
        } = this.state;
        // all menu
        let tempMenu = [...menu];
        //transform value
        portion = parseInt(portion);
        price = parseFloat(price);

        // filter by menu type
        if (type !== 'All') {
            tempMenu = tempMenu.filter(menu => menu.type === type)
        }
        // filter by portion number
        if (portion !== 1) {
            tempMenu = tempMenu.filter(menu => menu.portion >= portion)
        }
        // filter by price
        tempMenu = tempMenu.filter(menu => menu.price <= price);
        // filter by search
        tempMenu = tempMenu.filter(menu => {
            const regex = new RegExp(`^${searchMenu}`, 'gi');
            return menu.name.match(regex);
        })
        // filter by vegeterian availability
        if (vegeterian) {
            tempMenu = tempMenu.filter(menu => menu.vegeterian === true);
        }
        // filter by glutenFree availability
        if (glutenFree) {
            tempMenu = tempMenu.filter(menu => menu.glutenFree === true);
        }

        this.setState({
            sortedMenu: tempMenu
        });

    };

    render() {

        return (
            <MenuContext.Provider value={{ ...this.state, getMenu: this.getMenu, handleChange: this.handleChange }}>

                {this.props.children}
            </MenuContext.Provider>

        )

    }
}

const MenuConsumer = MenuContext.Consumer;

export function withMenuConsumer(Component) {
    return function ConsumerWrapper(props) {
        return <MenuConsumer>
            {value => <Component {...props} context={value} />}
        </MenuConsumer>
    }
}

export { MenuConsumer, MenuProvider, MenuContext };